import { GetSpecialPackageProducts, SelectedSpecialPackage } from "../../../features/client/clientInterface";
import { CreateClientRequest } from "../../../types/client";

interface UseValidateSpecialPackageProps {
    selectedSpecialPackage: SelectedSpecialPackage | null;
    clientData: CreateClientRequest;
    specialPackageItem: GetSpecialPackageProducts[] | null;
}

export const validateSpecialPackage = ({ selectedSpecialPackage, clientData, specialPackageItem }: UseValidateSpecialPackageProps) => {
    
    if (selectedSpecialPackage) {
        const { depositAmount, depositDate, endDate, endTime, receiptNumber, startDate, startTime } = selectedSpecialPackage;
        const clientScheduleFrom = clientData.scheduleFrom;
        const clientScheduleTo = clientData.scheduleTo;
        const clientStartTime = clientData.startTime;
        const clientEndTime = clientData.endTime;

        if (!depositAmount) {
            return "Deposit amount is required."
        }
        
        if (!depositDate) {
            return "Deposit date is required."
        }
        
        if (!receiptNumber) {
            return "Receipt number is required."
        }
        
        if (!startDate) {
            return "Special package start date is required."
        }
        
        if (!startTime) {
            return "Special package start time is required."
        }
        
        if (!endDate) {
            return "Special package end date is required."
        }
        
        if (!endTime) {
            return "Special package end time is required."
        }
        
        // Start date
        if (startDate < clientScheduleFrom) {
            return "Special package start date cannot be earlier than the client's start date."
        }
        
        if (startDate > clientScheduleTo) {
            return "Special package start date cannot be later than the client's end date."
        }
        // Start time
        if ( startDate === clientScheduleFrom && startTime < clientStartTime ) {
            return "Special package start time cannot be earlier than the client's start time."
        }
        if ( startDate === clientScheduleTo && startTime > clientEndTime ) {
            return "Special package start time cannot be later than the client's end time."
        }
        // End date
        if (endDate < clientScheduleFrom) {
            return "Special package end date cannot be earlier than the client's start date."
        }
        if (endDate > clientScheduleTo) {
            return "Special package end date cannot be later than the client's end date."
        }
        // End time
        if ( endDate === clientScheduleFrom && endTime < clientStartTime ) {
            return "Special package end time cannot be earlier than the client's start time."
        }
        if ( endDate === clientScheduleTo && endTime > clientEndTime ) {
            return "Special package end time cannot be later than the client's end time."
        }
        if (!specialPackageItem || specialPackageItem.length === 0) {
            return "At least one product is required."
        }
    }

    return null;
}